var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 10,
    viewBox: "0 0 21 10",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0657 0.098877H14.2571C14.2571 0.098877 15.0858 1.84066 17.0541 3.12475C19.0224 4.4088 20.2784 4.5487 20.2784 4.5487V5.47681C20.2784 5.47681 18.6857 5.65475 16.7821 7.19316C14.8787 8.73149 14.2571 9.90119 14.2571 9.90119H13.0657C13.0657 9.90119 14.3995 6.95158 15.7592 5.80732H0V4.29443H15.7462C15.7462 4.29443 13.7779 2.27293 13.0528 0.11159L13.0657 0.098877Z",
    fill: "#190C39"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.d859a48863ef2ee658119b995cf555c6.svg";
export { ForwardRef as ReactComponent };